module.exports = __webpack_public_path__ + "static/img/13.8c7ad5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/13.jpg
// module id = tbLk
// module chunks = 16